import React, { useState, useEffect } from "react";
import { Container, Col, Row, Image } from "react-bootstrap";
import { NavLink,useNavigate,useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import routes from "../routes";
import Hamburger from 'hamburger-react'
import driver from '../assets/img/driver.png'
// import logo1 from '../assets/img/Logo2x.png'
import recycling from '../assets/img/recycle10.png';
import { apiUrl } from "../commons/inFormTypes";
import { toast } from 'react-toastify';



function Header() {
  const [isToggle, setIsToggle] = useState(false);
  const [coint, setCoint] = useState(0)
  const navigate = useNavigate()
  const userToken = localStorage.getItem("user_token");
  const { pathname } = useLocation();

  const toggleHandler = () => {
    if (isToggle) setIsToggle(false);
    else setIsToggle(true);
  };

  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {
      const axios = require("axios");
      axios
        .post(apiUrl + "Get_DriverScore", {
          TokenId: userToken,
        })
        .then((res) => {
          if (res.data.result === "true") {
            setCoint(res.data.data);
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }, []);

  return (
    <div>
      <header>
      <Container fluid className="rgc-header pt-1">
          <Row className="justify-content-center align-items-center g-0">

            <Col xs={1}  className="rgc-icon-header" >
              {pathname === "/admin/dashboard" ?
                <i class="fa-solid fa-bell"></i>
                :
                <i className="fa fa-arrow-right" onClick={() => navigate(-1)}></i>
              }
            </Col>

            <Col xs={4}  className="rgc-header-score text-center text-md-end" >
              <span>{coint} &nbsp;امتیاز</span>
            </Col>

            <Col xs={2} className="text-center rgc-logo-header">
              <Image src={recycling} alt="logo"/>
              {/* <span>زیستماند</span> */}
            </Col>

            <Col xs={5}  className="header_toggle text-start">
              {pathname === "/admin/dashboard" ?
                <Hamburger toggled={isToggle} toggle={toggleHandler} style={{ width: "0" }} />
                :
                <NavLink to='dashboard' aria-current="page" >
                  <i class="fas fa-home rgc-home"></i>
                </NavLink>
              }
            </Col>

          </Row>
        </Container>
        {/* <Container fluid className="rgc-header pt-1">
          <Row className="justify-content-center align-items-center">

            <Col xs={2} md={5} className="rgc-icon-back" >
              <i class="fa fa-arrow-right" onClick={() => navigate(-1)}></i>
            </Col>

            <Col xs={3} md={2} className="text-center">
              <Image src={recycling} alt="logo" className="rgc-logo-header" />
            </Col>

            <Col xs={5} md={4} className="rgc-header-score text-start" >
              <span>{coint} &nbsp;امتیاز</span>
            </Col>

            <Col xs={2} md={1} className="header_toggle text-start">
              <Hamburger toggled={isToggle} toggle={toggleHandler} style={{ width: "0" }} />
            </Col>

          </Row>
        </Container> */}
      </header>
      <Sidebar routes={routes} toggle={isToggle} toggleHandler1={toggleHandler} />
    </div>
  );
}

export default Header;